
import Vue from 'vue'
import AppMixin from '@/_mixins/app'

import { PSI, User } from '@/views/Project/PSI/types/psi'

import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'
import UserAutocomplete from '@/views/User/components/userAutocomplete.vue'
import PsiAutocomplete from '@/views/Project/PSI/components/psiAutocomplete.vue'
import VbitStatusBanner from '@/components/banner/vbitStatus.vue'

const PsiIndex = Vue.extend({
    mixins: [AppMixin],
    components: { ToolbarComponent, UserAutocomplete, PsiAutocomplete, VbitStatusBanner },
    data() {
        return {
            authorized: false,
            userSearch: null as null | User,
            psiSearch: null as null | PSI,
        }
    },

    computed: {
        route: {
            get: function () {
                return this.$route.name
            },
            set: function (name: string | null | undefined) {
                name ? this.$router.push({ name: name }) : null
            },
        },
    },

    mounted() {
        this.authorized = this.hasPermission(this.allPermissions, 'psi.view')
    },
})

export default PsiIndex
